import React from 'react';

import GalleryView from './GalleryView';

function Gallery(props) {
  return <GalleryView {...props} />;
}

export default Gallery;
